import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from '../constants';
import { PaymentMethod } from './types';

export type Response = PaymentMethod;

export default (makeCall: MakeCall) =>
  (uuid: string, confirmationToken: string) =>
    makeCall<Response>('PUT', `${APIV2_URL}/payment/method/pay-in/${uuid}`, {
      data: { token1: confirmationToken },
    });
